module.exports = __webpack_public_path__ + "img/nevron_logo.png";